import { render } from "./CartIndex.vue?vue&type=template&id=3fafdcf4"
import script from "./CartIndex.vue?vue&type=script&lang=js"
export * from "./CartIndex.vue?vue&type=script&lang=js"

import "./CartIndex.vue?vue&type=style&index=0&id=3fafdcf4&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__